import { TransformedTranslationType } from '.'
import { NewsTranslation } from '../../classes/graphql'

export enum NewsContentType {
  CONTENT = 'content',
  URL = 'url'
}

export interface UINewsTranslation
  extends TransformedTranslationType<NewsTranslation> {
  formattedStartDate: string
  type: NewsContentType
}
